import { authHeader, handleResponse } from './helper';
import { getCookie } from './cookies';
import config from '../config';

const getLogs = async (params) => {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
      branch_office_id: getCookie('branch_office_id'),
    },
    body: JSON.stringify(params),
  };
  const url = new URL(`${config.apiGeneralUrl}/logs`);
  return await fetch(url, requestOptions).then(handleResponse);
};

export const historyService = {
  getLogs
};